export const UPDATE_STAFFING_STATE = 'UPDATE_STAFFING_STATE';
